import { SCREEN_SM } from "@rio-cloud/rio-uikit/utils/deviceUtils";
import { useEffect, useState } from "react";

const getQuery = (maxWidth: number) => `(max-width: ${maxWidth - 1}px)`;

export const useIsMobile = (maxWidth: number = SCREEN_SM) => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(getQuery(maxWidth)).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(getQuery(maxWidth));
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [maxWidth]);

  return isMobile;
};
